import StoreDetailedReport from "./StoreDetailedReport";

const Customers: React.FC = () => {
  return <StoreDetailedReport />;
};

export default Customers;
